var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 129,
    viewBox: "0 0 134 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_8205_543807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.002 112.325C98.4312 112.325 122.288 87.1558 122.288 56.1081C122.288 25.0605 98.4312 -0.108643 69.002 -0.108643C39.5729 -0.108643 15.7158 25.0605 15.7158 56.1081C15.7158 87.1558 39.5729 112.325 69.002 112.325Z",
    fill: "#F2F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.286 65.7803L72.6153 12.54L57.1505 25.2566L79.5102 49.2232L60.341 49.0806L53.0205 41.234L41.0249 57.8098L65.6258 84.1788L55.1867 93.8533L72.4177 112.324C97.0364 110.299 117.152 91.0388 122.286 65.7803Z",
    fill: "#C8BCFF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7187 51.6001L94.6874 51.6331L94.7187 51.6662L92.8597 53.6274L92.8284 53.5944L66.1465 81.7437L64.2875 79.7825L89.6559 53.0189H52.4341V50.2448H89.6547L64.2875 23.4812L66.1465 21.52L92.8284 49.6694L92.8597 49.6363L94.7187 51.5976V51.6001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M91.841 62.6727C97.6201 62.6727 102.305 57.7302 102.305 51.6332C102.305 45.5363 97.6201 40.5938 91.841 40.5938C86.0618 40.5938 81.377 45.5363 81.377 51.6332C81.377 57.7302 86.0618 62.6727 91.841 62.6727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M47.6894 63.2444C53.7677 63.2444 58.6952 58.0459 58.6952 51.6333C58.6952 45.2207 53.7677 40.0222 47.6894 40.0222C41.6111 40.0222 36.6836 45.2207 36.6836 51.6333C36.6836 58.0459 41.6111 63.2444 47.6894 63.2444Z",
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2008 51.1125H49.1759L49.4167 53.7584L49.8454 54.1204L50.7472 54.7263L47.6878 62.3515L44.6284 54.7263L45.5314 54.1204L45.96 53.7584L46.2008 51.1125Z",
    fill: "#F2AD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2207 54.316L42.7549 55.1467L47.6901 62.3527L51.8897 54.9053L50.1475 54.3223L48.6124 55.4642H46.7726L45.2207 54.3147V54.316Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1402 55.36L47.3509 55.9088L46.8813 62.1621L47.6904 62.8149L48.4995 62.1621L48.03 55.9088L48.2407 55.36L47.6904 55.3372L47.1402 55.36Z",
    fill: "#0F5F9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2627 54.302L40.9006 55.7716C40.9006 55.7716 40.3359 56.0803 40.1662 57.0228C40.0181 57.8408 39.935 58.6754 39.8242 59.7525C41.8217 61.9068 44.6077 63.2444 47.6912 63.2444C50.7746 63.2444 53.5595 61.9068 55.5582 59.7525C55.4474 58.6754 55.3643 57.8421 55.2162 57.0228C55.0452 56.079 54.4806 55.7716 54.4806 55.7716L50.1486 54.3223L47.6912 61.9246L45.2639 54.302H45.2627Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2637 54.302L44.3222 54.6196L44.1416 57.1384C44.1416 57.1384 44.191 57.3454 44.3403 57.3277L45.1891 57.6643C45.1891 57.6643 45.2445 57.7227 45.1951 57.7976L44.4691 58.3235L46.9313 63.2177C47.1829 63.2355 47.4358 63.2456 47.691 63.2456C47.9475 63.2456 48.1991 63.2355 48.4507 63.2177L50.9129 58.3235L50.1857 57.7976C50.1363 57.7227 50.1917 57.6643 50.1917 57.6643L51.0406 57.3277C51.1898 57.3454 51.2392 57.1384 51.2392 57.1384L51.0598 54.6272L50.1484 54.3236L47.691 61.9246L45.2649 54.302H45.2637Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2252 45.7316C44.2252 45.978 44.1397 46.2181 44.1457 46.4544C43.3487 46.2981 43.7328 48.7967 44.1855 49.1409C44.2216 49.1688 44.3095 49.1079 44.3841 49.057C44.5407 49.9767 45.8759 52.432 46.7247 53.466C46.9607 53.7531 48.4031 53.748 48.6355 53.4761C49.5048 52.4663 50.84 49.9805 50.9977 49.057C51.0712 49.1066 51.1591 49.1676 51.1964 49.1409C51.6479 48.7967 52.0332 46.2981 51.2349 46.4544C51.2409 46.2181 51.1567 45.978 51.1567 45.7316C51.1133 43.792 49.447 42.8228 47.6915 42.8152C45.9361 42.8241 44.271 43.792 44.2264 45.7316H44.2252Z",
    fill: "#FFBC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2928 43.2444C45.0423 43.2139 44.1333 43.5073 44.025 44.521C43.9154 45.5346 43.9684 46.4695 43.9684 46.4695C43.9684 46.4695 44.5005 46.6118 44.568 47.1872C44.6342 47.7626 44.586 47.7626 44.586 47.7626L44.7799 47.7168L44.9171 46.7299C45.713 46.204 44.9099 45.4241 45.707 45.2412C47.8573 46.8582 49.7548 46.5813 50.6109 45.8217C50.6109 45.8217 50.411 46.6168 50.5651 46.9001C50.7192 47.1846 50.6265 47.6305 50.6265 47.6305L50.8264 47.6216C50.8264 47.6216 50.7903 46.4492 51.2345 46.4542C52.9213 43.515 47.5804 39.8643 45.294 43.2444H45.2928Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9408 53.3809C46.0034 53.3847 45.2124 54.3259 45.2124 54.3259L45.8854 56.7584L47.689 55.337C46.6969 54.8226 46.1046 54.157 45.9396 53.3809H45.9408ZM49.4397 53.3809C49.3783 53.3847 50.1681 54.3259 50.1681 54.3259L49.495 56.7584L47.6902 55.337C48.6835 54.8226 49.2747 54.157 49.4397 53.3809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M65.0923 26.4309C69.856 26.4309 73.7178 22.3568 73.7178 17.3311C73.7178 12.3053 69.856 8.2312 65.0923 8.2312C60.3286 8.2312 56.4668 12.3053 56.4668 17.3311C56.4668 22.3568 60.3286 26.4309 65.0923 26.4309Z",
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3477 20.4162C61.8858 19.4598 62.7359 18.3509 61.8738 16.6653C60.6048 10.8096 66.455 9.62318 67.3388 12.0404C68.7788 12.612 68.7402 15.7647 68.001 17.4147C67.9673 18.093 67.2991 18.6849 68.5067 20.4353L68.5934 20.415C67.0257 20.8951 63.0056 20.6741 61.3489 20.4162H61.3477Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8863 17.383C63.327 18.3598 63.4895 18.7408 64.0373 19.1803C63.9506 20.8659 63.0922 20.8659 62.1362 21.3892L68.2273 21.5315C67.2026 20.9155 66.2406 20.9993 66.1491 19.1803C66.697 18.7408 66.8595 18.3598 67.3014 17.383C67.4085 17.4427 67.5229 17.5227 67.6108 17.4185C67.6975 17.3144 68.1153 15.9629 68.0406 15.78C67.9046 15.4497 67.7047 16.0658 67.6602 15.8638C67.559 15.3303 67.246 14.7028 67.134 13.3145C65.8758 15.7685 62.2518 14.76 62.4071 15.7965C61.7003 15.2757 62.5588 17.3982 62.5757 17.4185C62.6635 17.5227 62.7767 17.4427 62.8863 17.383Z",
    fill: "#FFBC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0375 19.1817C64.0135 19.6453 63.9316 19.9819 63.8052 20.236L65.1777 21.101L66.4143 20.3211C66.2686 20.0531 66.1747 19.6923 66.1482 19.1804C65.8556 19.4103 65.6377 19.6568 65.1862 19.6568C64.7142 19.658 64.4626 19.418 64.0375 19.1804V19.1817Z",
    fill: "#F2AD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.745 20.344C63.5897 20.6006 63.3814 20.7644 63.1406 20.9016L65.1621 24.9435L67.038 20.8978C66.7683 20.7454 66.5419 20.5561 66.3842 20.2437L65.1019 20.9156L65.0622 20.9181L63.9232 20.2754L63.7438 20.344H63.745Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7785 20.9318L64.8989 21.3078L64.6328 25.596L65.0903 26.0432L65.5491 25.596L65.283 21.3078L65.4034 20.9318L65.0903 20.9153L64.7773 20.9318H64.7785Z",
    fill: "#0F5F9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1407 20.9015C62.4689 21.2787 61.2384 20.8227 60.4727 22.1285C60.3763 22.2911 60.3198 23.7404 60.1211 24.7667C61.5262 25.8147 63.2407 26.4307 65.0924 26.4307C66.9466 26.4307 68.6647 25.8134 70.071 24.7629C69.8928 23.7379 69.8952 22.2911 69.8001 22.1298C69.0307 20.8202 67.7123 21.28 67.0393 20.8989L65.1635 24.9446L63.1419 20.9027L63.1407 20.9015Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8886 19.865L63.584 20.5344L64.4894 22.1412L65.0818 20.9167L63.8886 19.8663V19.865ZM66.2942 19.865L66.6048 20.5192L65.6934 22.14L65.1022 20.9155L66.2954 19.865H66.2942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2952 20.8064L65.1072 24.5295L66.8916 20.8077C66.9819 20.8674 67.077 20.922 67.1781 20.9728L65.1072 25.2408L63.0171 20.9678C63.1158 20.9182 63.2073 20.8649 63.2952 20.8052V20.8064Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M65.0931 104.365C72.7787 104.365 79.009 97.7921 79.009 89.6839C79.009 81.5757 72.7787 75.0027 65.0931 75.0027C57.4076 75.0027 51.1772 81.5757 51.1772 89.6839C51.1772 97.7921 57.4076 104.365 65.0931 104.365Z",
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2119 89.0261H66.9744L67.2779 92.3719L67.8197 92.8304L68.9611 93.5964L65.0926 103.237L61.2241 93.5964L62.3655 92.8304L62.9073 92.3719L63.2119 89.0261Z",
    fill: "#F2AD74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9687 93.0754L58.8516 94.1259L65.0919 103.236L70.4004 93.8211L68.1983 93.0843L66.2574 94.5286H63.9313L61.9687 93.0754Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3971 94.3966L64.6632 95.0902L64.0708 102.996L65.093 103.822L66.1164 102.996L65.5228 95.0902L65.7889 94.3966L65.093 94.3674L64.3971 94.3966Z",
    fill: "#0F5F9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0247 93.0586L56.5092 94.9169C56.5092 94.9169 55.7952 95.3069 55.5797 96.4996C55.3919 97.5349 55.2871 98.5891 55.1475 99.9508C57.6735 102.674 61.1952 104.366 65.0937 104.366C68.9911 104.366 72.514 102.674 75.04 99.9508C74.9004 98.5891 74.7956 97.5349 74.6078 96.4996C74.3923 95.3082 73.6783 94.9169 73.6783 94.9169L68.2013 93.0853L65.0949 102.697L62.0259 93.0599L62.0247 93.0586Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0233 93.0589L60.8337 93.4603L60.605 96.6434C60.605 96.6434 60.6676 96.9064 60.8566 96.8835L61.9306 97.309C61.9306 97.309 62.0004 97.3827 61.9378 97.4767L61.018 98.141L64.1315 104.33C64.4494 104.351 64.7684 104.365 65.0923 104.365C65.415 104.365 65.734 104.351 66.0531 104.33L69.1655 98.141L68.2468 97.4767C68.1842 97.3827 68.254 97.309 68.254 97.309L69.3268 96.8835C69.5158 96.9064 69.5784 96.6434 69.5784 96.6434L69.3509 93.4692L68.1986 93.0843L65.0923 102.695L62.0233 93.0576V93.0589Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7126 82.2226C60.7126 82.5338 60.6043 82.8387 60.6127 83.1372C59.6049 82.939 60.0902 86.098 60.6621 86.5325C60.7078 86.568 60.8186 86.4905 60.9125 86.427C61.1099 87.5893 62.7992 90.6937 63.8719 92.0008C64.1705 92.3628 65.9946 92.3577 66.2896 92.0135C67.3888 90.7369 69.0756 87.5944 69.2755 86.427C69.3694 86.4905 69.4802 86.568 69.5259 86.5325C70.0966 86.098 70.5831 82.939 69.5753 83.1372C69.5837 82.8387 69.4754 82.5351 69.4754 82.2226C69.42 79.7698 67.313 78.5453 65.094 78.5352C62.8738 78.5453 60.768 79.7698 60.7126 82.2226Z",
    fill: "#FFBC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0624 79.0777C61.7446 79.0396 60.5959 79.4105 60.4587 80.6921C60.3202 81.9738 60.3864 83.1551 60.3864 83.1551C60.3864 83.1551 61.0583 83.3355 61.1438 84.062C61.228 84.7899 61.1666 84.7899 61.1666 84.7899L61.411 84.7314L61.5844 83.4841C62.591 82.8198 61.576 81.8328 62.5825 81.6029C65.3024 83.6479 67.7008 83.2974 68.7832 82.3371C68.7832 82.3371 68.5303 83.3431 68.7254 83.7013C68.9192 84.0608 68.8036 84.6247 68.8036 84.6247L69.0565 84.6133C69.0565 84.6133 69.0107 83.131 69.5718 83.1386C71.7053 79.4232 64.9508 74.8072 62.06 79.0802L62.0624 79.0777Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8815 91.8938C62.961 91.8989 61.9604 93.0878 61.9604 93.0878L62.8117 96.163L65.0933 94.3669C63.8387 93.7166 63.0886 92.8757 62.8815 91.8938ZM67.305 91.8938C67.2268 91.8989 68.2261 93.0878 68.2261 93.0878L67.3749 96.163L65.0933 94.3669C66.3478 93.7166 67.0967 92.8757 67.305 91.8938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M91.8406 60.3201C96.3883 60.3201 100.075 56.4308 100.075 51.6331C100.075 46.8354 96.3883 42.946 91.8406 42.946C87.293 42.946 83.6064 46.8354 83.6064 51.6331C83.6064 56.4308 87.293 60.3201 91.8406 60.3201Z",
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.33 45.3862H93.3544V50.0378H97.7635V53.2286H93.3544V57.8801H90.33V53.2286H85.9209V50.0378H90.33V45.3862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0935 74.3193C73.1375 74.3193 79.6584 81.1975 79.6584 89.6852C79.6584 98.1715 73.1375 105.051 65.0935 105.051C57.0496 105.051 50.5287 98.1715 50.5287 89.6852C50.5287 81.1988 57.0496 74.3193 65.0935 74.3193ZM47.6908 38.9805C54.3153 38.9805 59.6851 44.6457 59.6851 51.6344C59.6851 58.6219 54.3153 64.2871 47.6908 64.2871C41.0676 64.2871 35.6978 58.6219 35.6978 51.6344C35.6978 44.6457 41.0676 38.9805 47.6908 38.9805ZM65.0935 7.16528C70.4152 7.16528 74.728 11.7165 74.728 17.3296C74.728 22.944 70.4152 27.4939 65.0935 27.4939C59.7718 27.4939 55.4591 22.944 55.4591 17.3296C55.4591 11.7152 59.773 7.16528 65.0935 7.16528Z",
    stroke: "white",
    strokeWidth: 2.16782
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8205_543807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 128,
    fill: "white",
    transform: "translate(0 0.480469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomImport);
export default __webpack_public_path__ + "static/media/CustomImport.f2d0476ffcc16942cbf4d9397c43f324.svg";
export { ForwardRef as ReactComponent };